export function getUniqueAssets(proposal) {
    const assetsMap = {};
    proposal.proposal_services.forEach(ps => ps.assets && ps.assets.forEach(a => assetsMap[a.asset_number] = a));
    return Object.keys(assetsMap).map(key => assetsMap[key]);
}